import Information from "./Information/index";
import InformationForm from "./Information/form";

import Role from "./Role/index";
import RoleForm from "./Role/form";

import Log from "./Log/index";
import SecurityLog from "./SecurityLog/index";

import TwoFactorSettings from "./TwoFactor/index";
import PasswordPolicySettings from "./passwordPolicySettings/index";

export const Admin = {
  Information,
  InformationForm,
  Log,
  SecurityLog,
  Role,
  RoleForm,
  TwoFactorSettings,
  PasswordPolicySettings,
};
